import { inject } from "mobx-react";
import { useMemo } from "react";
import { useLocation } from "react-router";

import type {
    Block_SitesItemBlock_Fragment,
    PreviousNextItemFragment,
    PublishRecordFragment,
} from "@ihr-radioedit/inferno-webapi";
import { previousNextViewNameToTitle } from "../../lib/coastContent";
import "./CoastPreviousNext.style.scss";
import { CoastPreviousNextItem } from "./CoastPreviousNextItem.component";
import type { Store } from "../../../../../client/stores";

interface CoastPreviousNextProps {
    block: Block_SitesItemBlock_Fragment;
    items: PreviousNextItemFragment[];
    curItem: PublishRecordFragment;
    store?: Store;
}

export const CoastPreviousNext = inject("store")(({ store, items, curItem, block }: CoastPreviousNextProps) => {
    if (!store) {
        return null;
    }

    const curItemIdx = useMemo(() => items.findIndex(item => item.slug === curItem.slug), [curItem.slug, items]);

    if (curItemIdx === -1) {
        return null;
    }

    const title = useMemo(
        () =>
            block.value.title ||
            (store.page.currentPage?.name
                ? `More ${previousNextViewNameToTitle(store.page.currentPage.name)}`
                : "More"),
        [block.value.title, store.page.currentPage?.name],
    );
    const previousItem = items[curItemIdx + 1];
    const nextItem = items[curItemIdx - 1];
    const location = useLocation();
    const [, basePath] = location.pathname.match(/(\/\w+)/) || [null, null];

    if (!previousItem && !nextItem) {
        return null;
    }

    return (
        <section className="component-coast-previous-next">
            <h2>{title}</h2>
            <div className="previous-next-items">
                {previousItem ? (
                    <CoastPreviousNextItem item={previousItem} type="previous" basePath={basePath} />
                ) : null}
                {nextItem ? <CoastPreviousNextItem item={nextItem} type="next" basePath={basePath} /> : null}
            </div>
        </section>
    );
});
